import { LocationStrategy } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MenuItem } from "primeng/api";
import { Observable, of as ObservableOf } from "rxjs";
import { shareReplay, switchMap } from "rxjs/operators";
import { routes } from "../app.routes";
import { AccessService } from "../services/access.service";
import { RouterService } from "../services/router.service";
import { SecondaryNavService } from "../services/secondary-nav.service";
import { AuthService } from "./../services/auth.service";

@Component({
  standalone: false,
  selector: "flyht-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.scss"],
})
export class NavMenuComponent implements OnInit {
  expandNavMenu: boolean = false;
  isSmallScreen: boolean;

  // Modal related
  displayModal: boolean = false;
  productName: string;
  productDescription: string;
  productImagePath: string;
  hasSubHeader: boolean;
  currentBaseRoute: string;

  logoUrl: string;

  enableUserManagement$: Observable<{ value: boolean }>;

  mainMenuItems: MenuItem[];
  userMenuItems: MenuItem[];

  constructor(
    public auth: AuthService,
    public routerService: RouterService,
    public locationStrategy: LocationStrategy,
    public secondaryNav: SecondaryNavService,
    private accessService: AccessService
  ) {

    this.logoUrl = this.locationStrategy.prepareExternalUrl(
      "./global/images/jetbridge-logo-dark.png"
    );
  }

  ngOnInit(): void {
    this.routerService.onUpdate.subscribe((newRoute) =>
      this.updateSubHeader(newRoute)
    );

    this.enableUserManagement$ = this.shouldDisplayItem("UserManagement");
    this.mainMenuItems = [
      {
        label: "Home",
        routerLink: "/home",
      },
      {
        label: "About",
        routerLink: "/about",
      },
      {
        label: "Contact Us",
        command: () => {
          window.open("https://flyht.com/contact/", "_blank");
        },
      },
    ];
    this.userMenuItems = [
      {
        label: "Logout",
        icon: "fas fa-sign-out-alt icon",
        command: () => {
          this.auth.logout();
        },
      },
    ];
    this.secondaryNav.setItems([
      {
        label: "Company",
        routerLink: "/user-management/company",
      },
      {
        label: "User",
        routerLink: "/user-management/user",
      },
    ]);
  }

  shouldDisplayItem(itemName: string): any {
    return this.accessService.shouldShowItem(itemName).pipe(
      switchMap((enable) => ObservableOf({ value: enable })),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  toggleNavigation() {
    this.expandNavMenu = !this.expandNavMenu;
  }

  updateSubHeader(newRoute: string) {
    const routeSplit = newRoute.split("/");
    this.currentBaseRoute = routeSplit[1];

    const thisRoute = routes.find(
      (route) => route.path === this.currentBaseRoute
    );
    if (thisRoute && thisRoute.children && thisRoute.children.length > 1) {
      this.hasSubHeader = true;
      this.secondaryNav.setActive(newRoute)
    } else {
      this.hasSubHeader = false;
    }
  }
}
